import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'bskfilter',
    templateUrl: 'bskfilter.component.html',
    styleUrls: ['bskfilter.component.scss'],
})
export class BskFilterComponent implements OnInit {
    @Input() public dataBskFilter;
    @Output() public clickFilter = new EventEmitter<any>();

    public ngOnInit(){

    }


    public onClickFilter() {
        this.clickFilter.emit(this.dataBskFilter);
    }
}


